import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { LoadingBarService } from '@core/services/loading-bar.service';

/**
 * Linha fina em terracota no topo da tela.
 * Fica visível durante operações em background como atualização de token.
 */
@Component({
	selector: 'os-loading-bar',
	templateUrl: './loading-bar.component.html',
	styleUrl: './loading-bar.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoadingBarComponent {
	readonly loadingBarService = inject(LoadingBarService);
}
